<main>
  <ng-content></ng-content>
  <router-outlet></router-outlet>
  <div class="section__bg sm:pt-[4.3rem] pt-0 sm:pb-[7.8rem] pb-8">
    <app-tools-jumbotron
      [pageInfo]="{
        title: 'Thanks for your support',
        descriptions: ['ThanksForYourSupport1'],
      }"
      [icons]="[
        {
          path: '/contact-us',
          insideRouter: true,
          icon: '/assets/media/svg/contact-us/sms.svg',
        },
        {
          path: 'https://www.facebook.com/Posty5App/',
          insideRouter: false,
          icon: '/assets/media/svg/contact-us/facebook.svg',
        },
        {
          path: 'https://www.youtube.com/@posty5',
          insideRouter: false,
          icon: '/assets/media/svg/contact-us/youtube.svg',
        },
      ]"
    ></app-tools-jumbotron>
  </div>
</main>

<footer app-footer></footer>
